import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      score: {
        main: {
          LAST_UPDATE_DATE: 'Last updated date:',
          PERIOD: 'Period:',
          YEARLY: 'Yearly',
          QUARTERLY: 'Quarterly',
          MONTHLY: 'Monthly',
          POINT_LADDER: {
            AGG_RISK: ' Aggressive Risk',
            SIGN_RISK: 'Significant Risk',
            MODE_RISK: 'Moderate Risk',
            LOW_RISK: 'Low Risk',
            VERY_LOW_RISK: 'Very Low Risk',
          },
          MONTHS: '%{month} months',
          DETAILS: 'Detail',
        },
        hightLight: {
          CORPORATE_RISK_SCORE: 'Corporate Risk Score',
          TRADE_CREDIT_LIMIT: 'Trade Credit Limit Recommendation',
          CORPORATE_PERFORMANCE_SCORE: 'Corporate Performance Score',
          TEXT_TOOLTIP_TRADE:
            'The Trade Credit Limit Recommendation refers to the total amount of all exposures toward a customer (i.e., the total of all payment receivables, invoices, bills, and other trade credit lines). The recommended limit is derived from our framework for assessing the total maximum exposure based on the information of customer and supplier such as credit score, financial positions, and so on. There are no universal, or generally accepted, approaches for setting business credit limits that capture the risk factors. Our recommended limit only works as a reference based on data that we perceived. Although a lot of efforts have been made by FiinGroup to ensure the accuracy of the data, FiinGroup makes no warranty regarding the accuracy and completeness of such information.',
        },
        standard: {
          CORPORATE_SCORING: 'CORPORATE SCORING',
          CONTACT_US: 'Contact Us',
          ABOUT_FIIN: "About FiinGroup's Predictive Models",
          ADVANTAGES_MODEL: 'Advantages of our models:',
          LIST_ADVANTAGES_MODEL: {
            TEXT_1: 'Processing large volumes of transactions more quickly',
            TEXT_2:
              'Making it possible to make more consistent decisions across all segments, industries, portfolios, and so on.',
            TEXT_3:
              'Automated decision-making process helps improve efficiency and free up valuable resources to focus on more important decisions.',
            TEXT_4:
              "FiinGroup's Predictive Models provide customers with insightful analytics into how an organization is likely to perform in the future.",
            TEXT_5:
              'Our Models combine sophisticated machine learning algorithms with a large Vietnamese enterprise database. By identifying late payments and high-risk organizations, we assist customers in making decisions that drive growth, mitigate risk, and increase profitability.',
            TEXT_6:
              'Our scoring models are not available for Banks, Fund, Insurance and other Financial Institutions, except Securities Firms.',
          },
          QUESTION: 'Which score types are offered on FiinGate?',
          CREDIT_SCORE: 'Corporate Risk Score',
          CORPORATE_SCORE: 'Corporate Performance Score',
          UPGRADE_NOW: 'Upgrade Now',
          REPORT: 'Score report is available on FiinGate Factsheet',
          CORPORATE_RISK_SCORE:
            'The Corporate Risk Score indicates a company’s likelihood of default, defined as ceasing operations within the next 12 months. Score range from 0 to 1000, with higher values indicating lower default risk. Each score range corresponds to a predefined Probability of Default (PD) based on a standardized Master Scale.',
        },
        premium: {
          TOOLTIP_TITLE_CREDIT:
            'The FiinGroup Corporate Credit Risk Score predicts the probability of a company falling into financial stress in 12-24 months. The Credit Score allows businesses to identify high credit-risk customers and prevent bad debts.\n\t\tThe score scale from 0-100, the higher, the better (better mean lower in credit risk)',
          TOOLTIP_TITLE_PERFORMANCE:
            'The Corporate Performance Score predicts the likelihood that an organization will outperform its peers in terms of future growth and profit. The score looks for businesses with high growth potential, suitable for long-term business relationship\n\t\tThe score scale from 0-100, the higher, the better (better mean the higher potential to outperform their peer in Revenue, and profit)',
          NODATA_TABLE:
            'This company has no Parent, Subsidiary, nor Associated Company',
          TOOLTIP_LABEL_TOP: 'The Performance Score ranges from 0 to 100.',
          TOOLTIP_LABEL_BOT: 'A higher score is better for the company.',
          SHORT_TERM: 'Short-term Credit Risk Score',
          MEDIUM_TERM: 'Medium-term Credit Risk Score',
          SHORT_TERM_PER: 'Short-term Performance Score',
          MEDIUM_TERM_PER: 'Medium-term Performance Score',
          NO_SCORE:
            'The score is not available due to the non-provision of data from the organization',
          RISK_SCORE: 'Risk Score',
          DESCRIPTION: 'Description',
          TOOLTIP_12M: 'Financial Stress probability',
          TOOLTIP_24M: 'Financial Stress probability in 24 months',
          TOOLTIP_PER_12M: 'High Growth potential probability',
          TOOLTIP_PER_24M: 'High Growth potential probability in 24 months',
          CORPORATE_LINKAGE_SCORE: 'Corporate Linkage Score',
          TABLE: {
            COMPANY_NAME: 'Company Name',
            TAX_CODE: 'Tax Code',
            RELATIONSHIP: 'Relationship',
            CREDIT: 'Corporate Credit Risk Score',
            PERFORMANCE: 'Corporate Performance Score',
          },
          TREND_OF_SCORE: 'Trend of Score',
          MEDIAN_SCORE: 'Median Score',
          SHOW_RANGE: 'Show Interquartile Range',
          FOOTER: {
            COMPANY: 'Company: %{description}',
            INDUSTRY: 'Industry: %{description}',
            REGION: 'Region: %{description}',
            YEAR_OF: 'Years in Operation: %{description}',
            TEXT_NOTI1: '* This chart does not cover companies without data',
            TEXT_NOTI2:
              '* The data for the last year is preliminary since at least 70% companies in the industry publish their financial statements',
          },
          DYNAMIC: {
            COMPANY: 'Company',
            INDUSTRY: 'Industry',
            REGION: 'Region',
            YEAR: 'Years in Operation',
          },
          DISTRIBUTION: {
            COMPANY: 'By Company',
            INDUSTRY: 'By Industry',
            REGION: 'By Region',
            YEAR: 'By Years in Operation',
            NAME_CHART: 'Distribution for the last 2 years',
            TEXT_LENGEND: 'Category that this company belongs to',
          },
        },
        performance: {
          TITLE_PANEL: 'Corporate Performance Score',
        },
      },
      domesticSearch: {
        LEAVE_US_A_MESSAGE_TO_CONTACT:
          'Leave us a message and we will contact you as soon as posible!',
        FULL_NAME: 'Full name',
        EMAIL: 'Email',
        PHONE_NUMBER: 'Phone number',
        LEAVE_US_A_MESSAGE: 'Leave us a message',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      score: {
        main: {
          LAST_UPDATE_DATE: 'Ngày cập nhật gần nhất:',
          PERIOD: 'Hiển thị:',
          YEARLY: 'Theo năm',
          QUARTERLY: 'Theo quý',
          MONTHLY: 'Theo tháng',
          POINT_LADDER: {
            AGG_RISK: ' Rủi ro rất cao',
            SIGN_RISK: 'Rủi ro cao',
            MODE_RISK: 'Rủi ro trung bình',
            LOW_RISK: 'Rủi ro thấp',
            VERY_LOW_RISK: 'Rủi ro rất thấp',
          },
          MONTHS: '%{month} tháng',
          DETAILS: 'Chi tiết',
        },
        hightLight: {
          CORPORATE_RISK_SCORE: 'Điểm rủi ro doanh nghiệp',
          TRADE_CREDIT_LIMIT: 'Hạn mức tín dụng khuyến nghị',
          CORPORATE_PERFORMANCE_SCORE:
            'Điểm Triển Vọng Tăng Trưởng Doanh Nghiệp',
          TEXT_TOOLTIP_TRADE:
            'Hạn mức tín dụng khuyến mại được khuyến nghị là tổng số tiền của tất cả các rủi ro đối với khách hàng (nghĩa là tổng số tất cả các khoản phải thu, hóa đơn, biên lai và các hạn mức tín dụng thương mại khác). Giới hạn khuyến nghị được lấy từ khuôn khổ của chúng tôi để đánh giá tổng rủi ro tối đa dựa trên thông tin của khách hàng và nhà cung cấp như điểm tín dụng, tình hình tài chính, v.v. Không có cách tiếp cận phổ biến hoặc được chấp nhận rộng rãi nào để đặt giới hạn tín dụng kinh doanh nắm bắt được các yếu tố rủi ro. Giới hạn được đề xuất của chúng tôi chỉ hoạt động như một tài liệu tham khảo dựa trên dữ liệu mà chúng tôi được tiếp nhận. Mặc dù FiinGroup đã nỗ lực để đảm bảo tính chính xác của dữ liệu, nhưng FiinGroup không đảm bảo về tính chính xác và đầy đủ của những thông tin đó.',
        },
        standard: {
          CORPORATE_SCORING: 'Mô hình Chấm điểm Doanh nghiệp',
          CONTACT_US: 'Liên hệ chúng tôi',
          ABOUT_FIIN: 'Về mô hình dự báo của FiinGroup',
          ADVANTAGES_MODEL: 'Điểm mạnh của mô hình:',
          LIST_ADVANTAGES_MODEL: {
            TEXT_1: 'Xử lý khối lượng giao dịch lớn nhanh hơn',
            TEXT_2:
              'Cho phép ra quyết định nhất quán hơn trên tất cả phân khúc thị trường, ngành, danh mục đầu tư...',
            TEXT_3:
              'Tự động hóa quy trình ra quyết định, giúp giải phóng các nguồn lực giá trị để tập trung vào các quyết định quan trọng hơn.',
            TEXT_4:
              'Mô hình Dự báo của FiinGroup cung cấp cho khách hàng những phân tích sâu sắc về triển vọng hoạt động của một tổ chức trong tương lai.',
            TEXT_5:
              'Mô hình của chúng tôi kết hợp các thuật toán máy học phức tạp và cơ sở dữ liệu toàn diện về các doanh nghiệp Việt Nam. Chúng tôi hỗ trợ khách hàng ra quyết định thúc đẩy tăng trưởng, giảm thiểu rủi ro và tăng lợi nhuận bằng cách xác định các khoản thanh toán quá hạn và các doanh nghiệp có độ rủi ro cao.',
            TEXT_6:
              'Mô hình của chúng tôi không khả dụng cho Ngân hàng, Quỹ, Công ty Bảo hiểm và các Tổ chức Tài chính khác, ngoại trừ Công ty Chứng khoán.',
          },
          QUESTION: 'FiinGate có những loại điểm số nào?',
          CREDIT_SCORE: 'Điểm Rủi ro Doanh nghiệp',
          CORPORATE_SCORE: 'Điểm Triển vọng Tăng trưởng Doanh nghiệp',
          UPGRADE_NOW: 'Nâng cấp ngay',
          REPORT:
            'Báo cáo về điểm số doanh nghiệp có thể được đính kèm trong FiinGate Factsheet',
          CORPORATE_RISK_SCORE:
            'Điểm rủi ro doanh nghiệp cho biết xác suất vỡ nợ của một doanh nghiệp, được định nghĩa là ngừng hoạt động trong vòng 12 tháng tới. Thang điểm từ 0 đến 1000, với điểm số cao hơn thể hiện rủi ro vỡ nợ thấp hơn. Mỗi khoảng điểm tương ứng với một xác suất vỡ nợ (PD) được chuẩn hóa theo thang điểm chuẩn.',
        },
        premium: {
          TOOLTIP_TITLE_CREDIT:
            'Điểm rủi ro tín dụng doanh nghiệp của FiinGroup dự đoán xác suất một công ty rơi vào tình trạng khó khăn tài chính trong 12-24 tháng tới. Điểm Tín dụng cho phép các doanh nghiệp xác định những khách hàng có rủi ro tín dụng cao và hỗ trợ ngăn ngừa nợ xấu có thể xuất hiện trong tương lai.\n\t\tThang điểm từ 0-100, với điểm cao hơn hàm ý rằng doanh nghiệp đó có rủi ro tín dụng thấp hơn.',
          TOOLTIP_TITLE_PERFORMANCE:
            'Điểm triển vọng tăng trưởng doanh nghiệp của FiinGroup dự đoán khả năng một doanh nghiệp sẽ đạt được tốc độ tăng trưởng và lợi nhuận đọt phá so trong tương lai. Điểm số này giúp tìm kiếm các doanh nghiệp có năng lực kinh doanh tốt và có thể xây dựng quan hệ hợp tác lâu dài\n\t\tThang điểm từ 0-100, điểm càng cao có nghĩa là tiềm năng vượt trội hơn về tăng trưởng doanh thu và lợi nhuận.',
          NODATA_TABLE:
            'Công ty này hiện không có công ty mẹ, công ty con hay công ty liên kết nào',
          TOOLTIP_LABEL_TOP: 'Điểm hiệu suất nằm trong khoảng từ 0 đến 100. ',
          TOOLTIP_LABEL_BOT: 'Một số điểm cao hơn là tốt hơn cho công ty.',
          SHORT_TERM: 'Điểm Rủi ro Tín dụng trong ngắn hạn',
          MEDIUM_TERM: 'Điểm Rủi ro Tín dụng trong trung hạn',
          SHORT_TERM_PER: 'Điểm Triển vọng Tăng trưởng trong ngắn hạn',
          MEDIUM_TERM_PER: 'Điểm Triển vọng Tăng trưởng trong trung hạn',
          NO_SCORE:
            'Điểm số không khả dụng do doanh nghiệp không cung cấp dữ liệu',
          RISK_SCORE: 'Hạng điểm',
          DESCRIPTION: 'Mô tả',
          TOOLTIP_12M: 'Xác suất chịu rủi ro tài chính',
          TOOLTIP_24M: 'Xác suất chịu rủi ro tài chính trong 24 tháng tới',
          TOOLTIP_PER_12M: 'Xác suất triển vọng tăng trưởng cao',
          TOOLTIP_PER_24M:
            'Xác suất triển vọng tăng trưởng cao trong 24 tháng tới',
          CORPORATE_LINKAGE_SCORE: 'Điểm Số Của Các Doanh Nghiệp Có Liên Quan',
          TABLE: {
            COMPANY_NAME: 'Tên công ty',
            TAX_CODE: 'Mã số thuế',
            RELATIONSHIP: 'Quan hệ',
            CREDIT: 'Điểm Rủi Ro Tín Dụng Doanh Nghiệp',
            PERFORMANCE: 'Điểm Triển Vọng Tăng Trưởng Doanh Nghiệp',
          },
          TREND_OF_SCORE: 'Xu hướng Điểm',
          MEDIAN_SCORE: 'Trung vị điểm',
          SHOW_RANGE: 'Hiển thị khoảng tứ phân vị',
          FOOTER: {
            COMPANY: 'Doanh Nghiệp: %{description}',
            INDUSTRY: 'Ngành: %{description}',
            REGION: 'Vùng: %{description}',
            YEAR_OF: 'Năm hoạt động: %{description}',
            TEXT_NOTI1:
              '* Biểu đồ không bao gồm các doanh nghiệp không có dữ liệu',
            TEXT_NOTI2:
              '* Số liệu của năm cuối cùng là sơ bộ do chỉ có ít nhất 70% doanh nghiệp trong ngành công bố báo cáo tài chính',
          },
          DYNAMIC: {
            COMPANY: 'Doanh Nghiệp',
            INDUSTRY: 'Ngành',
            REGION: 'Vùng',
            YEAR: 'Năm hoạt động',
          },
          DISTRIBUTION: {
            COMPANY: 'Doanh Nghiệp',
            INDUSTRY: 'Trong cùng ngành',
            REGION: 'Trong cùng khu vực địa lý',
            YEAR: 'Trong cùng số năm hoạt động',
            NAME_CHART: 'Phổ điểm của 2 năm gần nhất',
            TEXT_LENGEND: 'Ngưỡng điểm của công ty',
          },
        },
        performance: {
          TITLE_PANEL: 'Điểm triển vọng tăng trưởng doanh nghiệp',
        },
      },
      domesticSearch: {
        LEAVE_US_A_MESSAGE_TO_CONTACT:
          'Để lại yêu cầu và chúng tôi sẽ liên hệ bạn sớm nhất có thể!',
        FULL_NAME: 'Tên đầy đủ',
        EMAIL: 'Email',
        PHONE_NUMBER: 'Số điện thoại',
        LEAVE_US_A_MESSAGE: 'Để lại yêu cầu',
      },
    },
  }),
)
